// src/app/app.component.ts

import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // Remove or comment out the standalone property
  // standalone: true
})
export class AppComponent {
  title = 'transend-beyond-application-system';
}
